import React, { useState, useEffect, Fragment } from 'react';
import { isLoggedIn } from '../Login/utils/isLoggedIn';
import { LoggedInButtonContent } from './LoggedInButtonContent/LoggedInButtonContent';
import { AccountMenu } from './AccountMenu/AccountMenu';
import { getCookieValue } from '../../assets/js/utils/getCookieValue';
import { getXhrDomain } from '../../assets/js/utils/getXhrDomain';
import { handleGtmEvent } from '../../assets/js/utils/gtm';

function LoginStatus({
    meData: meDataProp,
    organizationData: organizationDataProp,
    selectedOrganizationId: selectedOrganizationIdProp,
    selectOrganizationApiUrl,
    signInPageUrl,
    signOutApiUrl,
    signOutRedirectUrl,
    dashboardPageUrl,
    forScreenType, // 'mobile' || 'desktop'
    resourcedTexts,
}) {
    const [meData, setMeData] = useState(meDataProp);
    const [organizationData, setOrganizationData] = useState(organizationDataProp);
    const [selectedOrganizationId, setSelectedOrganizationId] = useState(selectedOrganizationIdProp);
    const [menuIsOpen, setMenuIsOpen] = useState(false);
    const forDesktop = forScreenType === 'desktop';
    const forMobile = forScreenType === 'mobile';
    const isLoggedOut = !isLoggedIn(meData);

    useEffect(() => {
        const htmlEl = document.querySelector('html');

        htmlEl.addEventListener('loggedIn', (e) => {
            const { meData, organizationData, selectedOrganizationId } = e.detail;
            setMeData(meData);
            setOrganizationData(organizationData);
            setSelectedOrganizationId(selectedOrganizationId);
        });

        htmlEl.addEventListener('organizationChanged', (e) => {
            const { organizationId } = e.detail;
            setSelectedOrganizationId(organizationId);
        });
    }, []);

    function handleLoginInClick() {
        window.location.href = `${signInPageUrl}?redirectUrl=${window.location.pathname}`;
    }

    async function handleSelectOrganization(organization) {
        const antiForgeryResponse = await fetch(getXhrDomain() + '/antiforgery/token', {
            method: 'GET',
        });

        if (!antiForgeryResponse.ok) {
            const message = `An error has occurred: ${antiForgeryResponse.status}`;
            throw new Error(message);
        }
        const response = await fetch(selectOrganizationApiUrl, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'X-XSRF-TOKEN': getCookieValue('XSRF-TOKEN'),
            },
            body: JSON.stringify({
                organizationId: organization.id,
                organizationGroupsIds: organization.organizationGroups,
            }),
        });

        if (!response.ok) {
            const message = `An error has occurred: ${response.status}`;
            throw new Error(message);
        }

        handleGtmEvent('menu_organization_select');

        window.location.reload();

        return response;
    }

    function handleOrganizationClick(e, organizationId) {
        const selectedOrganization = organizationData.organizations.find((org) => org.id === organizationId);

        handleSelectOrganization(selectedOrganization).catch((error) => {
            console.error('error', error.message);
        });
    }

    async function handleSignOut() {
        const antiForgeryResponse = await fetch(getXhrDomain() + '/antiforgery/token', {
            method: 'GET',
        });

        if (!antiForgeryResponse.ok) {
            const message = `An error has occurred: ${antiForgeryResponse.status}`;
            throw new Error(message);
        }

        const response = await fetch(signOutApiUrl, {
            method: 'POST',
            headers: {
                'X-XSRF-TOKEN': getCookieValue('XSRF-TOKEN'),
            },
        });

        if (!response.ok) {
            const message = `An error has occurred: ${response.status}`;
            throw new Error(message);
        }

        window.location.href = signOutRedirectUrl;

        return response;
    }

    function handleSignOutClick() {
        handleSignOut().catch((error) => {
            console.error('error', error.message);
        });
    }

    if (isLoggedOut) {
        return (
            <a href="#" onClick={() => handleLoginInClick()} className="button login-button">
                {resourcedTexts.loginButton}
            </a>
        );
    }

    if (forMobile) {
        return (
            <a href={dashboardPageUrl} className="button login-button login-button--logged-in">
                <LoggedInButtonContent
                    meData={meData}
                    organizationData={organizationData}
                    selectedOrganizationId={selectedOrganizationId}
                />
            </a>
        );
    }

    if (forDesktop) {
        return (
            <Fragment>
                <button
                    className="button login-button login-button--logged-in"
                    type="button"
                    onClick={() => setMenuIsOpen(!menuIsOpen)}
                >
                    <LoggedInButtonContent
                        meData={meData}
                        organizationData={organizationData}
                        selectedOrganizationId={selectedOrganizationId}
                    />
                </button>

                {menuIsOpen && (
                    <AccountMenu
                        meData={meData}
                        organizationData={organizationData}
                        dashboardPageUrl={dashboardPageUrl}
                        selectedOrganizationId={selectedOrganizationId}
                        handleOrganizationClick={handleOrganizationClick}
                        handleMenuClose={() => setMenuIsOpen(false)}
                        handleSignOutClick={handleSignOutClick}
                        resourcedTexts={resourcedTexts}
                    />
                )}
            </Fragment>
        );
    }

    return null;
}

export { LoginStatus };
